import Cookies from 'js-cookie';

export default {
    classType: 'components',

    init() {
        // Allow support of language identifiers made of two or five characters
        // e.G. "fr" and "fr-FR"
        let browserLanguage = navigator.language.split('-')[0];

        // Check if the browser language is part of our languages allowed list
        // and format it according to our system
        if (appData.trans.localeAllowed.indexOf(browserLanguage) === -1) {
            browserLanguage = appData.trans.locale;
        }

        // If we were able to retrieve the browser language
        if (browserLanguage !== undefined) {
            // If it's different from the current website one
            // and we did not already asked the user
            let cookieLanguageSwitch = Cookies.get(
                'browser-language-suggestion-canceled'
            );

            if (
                browserLanguage !== appData.trans.locale &&
                !cookieLanguageSwitch
            ) {
                let url =
                    window.localSuggestionGetUrl &&
                    window.localSuggestionGetUrl(browserLanguage);
                // If there isn't any URL for this browser language to be redirected
                // use English by default
                if (
                    !window.localSuggestionGetUrl ||
                    !window.localSuggestionGetUrl(browserLanguage)
                ) {
                    browserLanguage = 'en';
                    url = window.localSuggestionGetUrl(browserLanguage);
                }

                // After a while, display the language suggestion box
                setTimeout(() => {
                    // Get the box and display it
                    let box = document.getElementById('language-switcher');
                    box.classList.add('language-switcher-shown');

                    // Change its message
                    document.getElementById(
                        'language-switcher-message'
                    ).innerHTML = this.app.locale.trans(
                        `locale.switch_to.${browserLanguage}`
                    );

                    // Get the language switch button and change its label
                    // to correspond to the targeted language
                    let button = document.getElementById(
                        'language-suggestion-button'
                    );
                    button.innerHTML = this.app.locale.trans(
                        `locale.button.${browserLanguage}`
                    );

                    // Make it redirect to the corresponding page
                    button.setAttribute('href', url);

                    // Get the cancel button and make it create a cookie
                    // to save user's choice
                    document
                        .getElementById('language-suggestion-cancel')
                        .addEventListener('click', () => {
                            Cookies.set(
                                'browser-language-suggestion-canceled',
                                true
                            );
                            box.classList.remove('language-switcher-shown');
                        });
                }, 2000);
            }
        }
    },
};
